import { useAuth0 } from '@auth0/auth0-react';
import { Dialog } from 'primereact/dialog';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { getLearnosityReports } from '../../../bffApiCalls/getLearnosityReports';
import ExitSlipFullDetailModalWrapper from './ExitSlipFullDetailModalWrapper';
import { LearnosityReportRequest } from '../../../models/LearnosityRequest';
import { FullDetailModalData, LearnosityReportData } from '../../../custom-hooks/useExitSlipChartValues';
import { usePostHog } from '@posthog/react';

interface Props {
  fullDetailModalData: FullDetailModalData;
  setFullDetailModalData: Dispatch<SetStateAction<FullDetailModalData>>;
  reportData: LearnosityReportData;
}

const ExitSlipFullDetailModal: FC<Props> = ({ fullDetailModalData, setFullDetailModalData, reportData }) => {
  const [request, setRequest] = useState<LearnosityReportRequest | null>(null);
  const { getAccessTokenSilently, logout } = useAuth0();
  const posthog = usePostHog();

  useEffect(() => {
    getLearnosityReports(
      {
        activityId: reportData.activityId,
        userId: reportData.userId,
        reportId: reportData.reportId,
        reportType: reportData.reportType,
        userIds: reportData.userIds,
        sessionIds: reportData.sessionIds,
      },
      getAccessTokenSilently,
      logout,
      posthog,
    )
      .then(data => {
        setRequest(data);
      })
      .catch(() => {
        console.log('Error fetching Learnosity bridge');
      });
  }, []);

  return (
    <Dialog
      className="nc_full-detail-modal"
      header={<h3>{fullDetailModalData.title}</h3>}
      visible={fullDetailModalData.visible}
      onHide={() => setFullDetailModalData({ ...fullDetailModalData, visible: false })}
    >
      {request && <ExitSlipFullDetailModalWrapper request={request} />}
    </Dialog>
  );
};

export default ExitSlipFullDetailModal;
